import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useCameras() {
  const { cameraTypes, visible } = useAppSelector((state) => state.camera);
  const { dataForPost } = useAppSelector((state) => state.star);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const cameraData = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "1e5570b4-1c55-46a0-9699-e5f47a873537",
    IncludeNonServiceBranches: false,
    Parameters: {
      "5187cad1-7f00-11ef-8d00-1062eb32e4ff": cameraTypes,
      "64150563-4f01-426a-9784-133a8ac77a94": date.created_after || "2020-06-03",
      "e6a07daf-6cfb-4466-9f8f-70d99307979d": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, cameraTypes],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        cameraData
      ).then((res) => {
        console.log(res.data.Rows, "jnkjnmjm");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
